module.exports = __webpack_public_path__ + "img/titleist_back_img2_m.a054767b.jpg";